import {
  HeaderTextWrapper,
  IntroDivider,
  IntroHeaderSubText,
  IntroHeaderText,
  IntroHeaderTextWrapper,
  LogoAndHeaderTextWrapper,
} from 'pages/Intro/IntroHeader/IntroHeader.styled';
import ShellLogo from 'pages/Intro/shell_logo.svg';

export const IntroHeader = ({ isMobile }: { isMobile: boolean }) => {
  return (
    <LogoAndHeaderTextWrapper isMobile={isMobile}>
      <img
        src={ShellLogo}
        alt="Shell Battery Management Hub Intro Logo"
        style={{ height: 40, width: 40, zIndex: 2 }}
      />
      <IntroHeaderTextWrapper>
        <IntroDivider />
        <HeaderTextWrapper>
          <IntroHeaderSubText isMobile={isMobile}>
            Shell Energy
          </IntroHeaderSubText>
          <IntroHeaderText isMobile={isMobile}>
            Battery Management Hub
          </IntroHeaderText>
        </HeaderTextWrapper>
      </IntroHeaderTextWrapper>
    </LogoAndHeaderTextWrapper>
  );
};
